import React from 'react'
import { useSelector } from 'react-redux'
import { useLocation } from 'react-router-dom'

const KullaniciIslemleri = () => {

  return (
    <div>KullaniciIslemleri</div>
  )
}

export default KullaniciIslemleri